import {ModalMoveTo_Type, MoveTo_CurrentStep} from "../@const"
import Workspace from "../../../model2/space/workspaces/workspace"
import ProjectSession from "../../../model2/project/project-session"
import Task from "../../../model2/task/task"
import Document from "../../../model2/doc/document"
import {EntityType} from "../../../gd/const/item"
import ProjectSessionCollection from "../../../model2/project/collection"
import Modal_getMissingUsers, {ModalMoveTo_MissingUsers} from "../actions/get-missing-users"
import ModalMoveTo_commitTaskMoveToFolder from "../actions/task-move/commit-task-move-to-folder"
import ModalMoveTo_commitTaskMoveToTask from "../actions/task-move/commit-task-move-to-task"
import ModalMoveTo_commitDocumentMoveToFolder from "../actions/document-move/commit-document-move-to-folder"
import ModalMoveTo_commitMeetingMoveToFolder from "../actions/meeting-move/commit-meeting-move-to-folder"
import ModalMoveTo_commitProjectMoveToFolder from "../actions/project-move/commit-project-move-to-folder"
import ModalMoveTo_commitMultiMoveToFolder from "../actions/multi-move/commit-multi-move-to-folder"
import Meeting from "../../../model2/meeting/meeting"
import {MissingUsersManagerInterface} from "../../components/add-missing-users/missing-users-manager-interface"

// const debug = "MoveTo_Manager"
const debug = false

export class MoveTo_Manager implements MissingUsersManagerInterface {

    public type                 : ModalMoveTo_Type
    public targetType           : EntityType

    public searchPrompt         : string = ''

    public reRender             : callback

    public originalProjectId?   : ID                // original value we use to determine if change has been made

    public targetWorkspace?     : Workspace         // workspace we add to
    public targetProject?       : ProjectSession    // project we add to
    public targetTask?          : Task              // task we add to

    public missingUsers?        : ModalMoveTo_MissingUsers

    public currentStep          : MoveTo_CurrentStep = MoveTo_CurrentStep.MAIN

    // PROJECT or MULTI
    public projectsToMove       : ProjectSession[] = []

    // TASK or MULTI
    public tasksToMove          : Task[] = []

    // DOCUMENT
    public documentToMove?      : Document

    // MEETING
    public meetingToMove?       : Meeting

    constructor(type:ModalMoveTo_Type, targetType: EntityType = EntityType.PROJECT) {
        this.type           = type
        this.targetType     = targetType
        this.reRender       = () => { console.warn('#kdjd83ss Not implemented'); }
    }

    setTargetProject = (projectId?:ID) => {

        const project = gd.session.projects.get(projectId)

        this.targetProject      = project || undefined
        this.targetWorkspace    = project?.workspace || undefined

        this.reRender()
    }

    setTargetTask = (task: Task) => {
        this.targetTask         = task
        this.targetProject      = task.project!
        this.targetWorkspace    = task.project?.workspace || undefined

        this.reRender()
    }

    setCurrentStep = (step: MoveTo_CurrentStep) => {
        this.currentStep = step
        this.reRender()
    }

    validateUsers = async () => {
        debug && console.log(debug, 'validateUsers', this)
        this.setCurrentStep(MoveTo_CurrentStep.CHECKING_USERS)

        this.missingUsers = await Modal_getMissingUsers(this)
        const clearedUsers = _.omitBy(this.missingUsers, _.isEmpty)

        debug && console.log(debug, 'validateUsers', this.missingUsers, clearedUsers)

        if (_.isEmpty(clearedUsers)) {
            this.commitMove()
        } else {
            this.onAddMissingUsers()
        }
    }

    commitMove = () => {
        debug && console.log(debug, 'commitMove')

        switch (this.type) {
            case ModalMoveTo_Type.TASK:
                switch (this.targetType) {
                    case EntityType.PROJECT:
                        ModalMoveTo_commitTaskMoveToFolder({
                            taskToMove      : this.tasksToMove[0],
                            targetProject   : this.targetProject!,
                        })
                        break

                    case EntityType.TASK:
                        ModalMoveTo_commitTaskMoveToTask({
                            taskToMove  : this.tasksToMove[0],
                            targetTask  : this.targetTask!,
                        })
                        break
                }
                break

            case ModalMoveTo_Type.DOCUMENT:
                ModalMoveTo_commitDocumentMoveToFolder({
                    documentToMove  : this.documentToMove!,
                    targetProject   : this.targetProject!,
                })
                break

            case ModalMoveTo_Type.MEETING:
                ModalMoveTo_commitMeetingMoveToFolder({
                    meetingToMove   : this.meetingToMove!,
                    targetProject   : this.targetProject!,
                })
                break

            case ModalMoveTo_Type.PROJECT:
                ModalMoveTo_commitProjectMoveToFolder({
                    projectToMove   : this.projectsToMove[0],
                    targetProject   : this.targetProject!,
                })
                break

            case ModalMoveTo_Type.MULTI:
                ModalMoveTo_commitMultiMoveToFolder({
                    tasksToMove     : this.tasksToMove,
                    projectsToMove  : this.projectsToMove,
                    targetProject   : this.targetProject!,
                })
                break
        }
    }

    commit() {
        this.commitMove()
    }

    onAddMissingUsers = () => {
        this.setCurrentStep(MoveTo_CurrentStep.ADD_MISSING_USERS)
    }

    get parentsFor():EntityType {
        switch (this.type) {
            case ModalMoveTo_Type.TASK:
                return EntityType.TASK

            case ModalMoveTo_Type.DOCUMENT:
                return EntityType.DOCUMENT

            case ModalMoveTo_Type.MEETING:
                return EntityType.MEETING

            case ModalMoveTo_Type.MULTI:
                return !_.isEmpty(this.tasksToMove) ? EntityType.TASK : EntityType.PROJECT

            case ModalMoveTo_Type.PROJECT:
                return EntityType.PROJECT

            default:
                throw new Error(`#kjkkdjdiew Unknown type ${this.type}`)
        }
    }

    get affectedProjectIds():ID[] {
        let res: ID[] = []
        _.map(this.projectsToMove, (project:ProjectSession)=>{
            res = res.concat([project.id]).concat(project.childrenProjectsIds)
        })

        return res
    }

    get affectedTasksIds():ID[] {
        return _.map(this.tasksToMove, (task:Task)=>{
            return task.id
        })
    }

    get availableProjects():ProjectSessionCollection|undefined {
        switch (this.type) {
            case ModalMoveTo_Type.PROJECT:
                const projectIds = [this.projectsToMove[0].id, ...this.projectsToMove[0].childrenProjectsIds]
                return gd.session.projects.filterAvailableProjects(projectIds)

            case ModalMoveTo_Type.MULTI:
                return gd.session.projects.filterAvailableProjects(this.affectedProjectIds)

            default:
                return undefined
        }
    }

    get showProjectAccess() {
        return !_.isEmpty(this.tasksToMove)
    }

    // SEARCH
    get searchEnabled (): boolean {
        return !!this.searchPrompt
    }

    public setSearchPrompt = (prompt:string):void => {
        this.searchPrompt = prompt
        this.reRender()
    }

    get modalTitle():string {

        switch (this.type) {
            default:
                return "Move"
        }
    }
}